import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import ButtonComponent from "@components/Theme/Button/Button"
import {AssetType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useState} from "react"

import GalleryPopup from "../../../Pages/Media/GalleryPage/GalleryContainerSection/GalleryPopup"
import Popup from "../../Popup/Popup"

import styles from "./GalleryCard.module.scss"

type Props = {
	element: AssetType
	className?: string
}

const GalleryCard = (props: Props) => {
	// Popup functionality
	const [popup, setPopup] = useState<boolean>(false)
	const changePopup = (): void => {
		setPopup(!popup)
	}

	return (
		<>
			<ButtonComponent
				buttonType={"unstyled"}
				className={`${styles.image} ${props.className}`}
				onClick={changePopup}
			>
				<NewResponsiveImage withoutContainer {...props.element} />
			</ButtonComponent>
			{popup && (
				<Popup
					handleClick={changePopup}
					module={<GalleryPopup data={props.element} />}
				/>
			)}
		</>
	)
}

export default GalleryCard
